import { object, string } from 'yup';
import '@client/yup';

export const EmailSchema = object().shape({
  email: string().label('Email').trim().email()
    .required(),
});
